import { i as h, r as f, a as v, S as l, N as m, x as c, e as g, n as o, t as u } from "./SelfServicePanelService.js";
const b = h`:host{display:contents}::slotted([data-pdk-panel-left-button]){position:absolute!important;top:0!important;left:4px!important;z-index:11!important;display:flex!important;align-items:center!important;height:48px!important;width:48px!important}@media (min-width: 768px){::slotted([data-pdk-panel-left-button]){left:8px!important;height:72px!important;width:72px!important}}.pdk-self-service-panel{--progress-bar-fill-width: 8px;background-color:#f9f9f9;--animation-time: 0ms;--offcanvas-bg-color: #f9f9f9;--offcanvas-bg-color-darker: #f0f2f3;--offcanvas-button-xy: 8px;--offcanvas-width: 70vw;position:fixed;bottom:0;top:0;right:0;width:100vw;height:100vh;display:none;flex-direction:column;justify-content:start;outline:0;overflow-x:hidden;overflow-y:auto;z-index:var(--zi-offcanvas);transform:translate(100%);animation:fadeOut var(--animation-time);-webkit-overflow-scrolling:touch;overscroll-behavior:none;touch-action:pan-x pan-y}.pdk-self-service-panel--show{display:flex}.pdk-self-service-panel--animate{--animation-time: .3s}.pdk-self-service-panel--showing,.pdk-self-service-panel--shown{animation:fadeIn var(--animation-time);transform:translate(0)}.pdk-self-service-panel--start{left:0}.pdk-self-service-panel--end{right:0}.pdk-self-service-panel--fullscreen{width:100vw}@media (min-width: 768px){.pdk-self-service-panel{max-width:640px}}.pdk-self-service-panel__body{display:flex;flex-direction:column;flex-grow:1;z-index:1;transition:.2s}.pdk-self-service-panel__backdrop{position:fixed;display:none;top:0;left:0;z-index:var(--zi-offcanvas-backdrop);width:100vw;height:100vh;background-color:#00000040;opacity:0;transition:opacity var(--animation-time) ease-in-out}.pdk-self-service-panel__backdrop--show{display:flex;opacity:.2}.pdk-self-service-panel__backdrop--showing{opacity:1}.pdk-self-service-panel__backdrop--animate{transition:opacity var(--animation-time) linear 0s}@keyframes fadeIn{0%{transform:translate(100%);display:none}to{transform:translate(0);display:flex}}@keyframes fadeOut{0%{transform:translate(0);display:flex}to{transform:translate(100%);display:none}}.pdk-self-service-panel__header{display:flex;align-items:center;justify-content:center;position:sticky;flex-shrink:0;top:0;overflow:hidden;background-color:#fff;z-index:10;transition:.2s;height:50px}@media (min-width: 768px){.pdk-self-service-panel__header{height:74px}}.pdk-self-service-panel__header-with-progress .pdk-self-service-panel__progress-fill{display:block!important;width:var(--progress-bar-fill-width)}.pdk-self-service-panel__header-with-progress .pdk-self-service-panel__progress{height:4px}@media (min-width: 768px){.pdk-self-service-panel__header-with-progress .pdk-self-service-panel__progress{height:8px}}.pdk-self-service-panel__header-content{display:flex;flex-direction:column;overflow:hidden;padding:0 24px}@media (min-width: 768px){.pdk-self-service-panel__header-content{padding:0 40px}}.pdk-self-service-panel__header-content--title{color:#4e617b;align-items:center;justify-content:center;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.pdk-self-service-panel__header--bottom-border{border-bottom:1px solid #e1e5e8}.pdk-self-service-panel__progress{--progress-bar-fill-width: 0%;position:absolute;bottom:0;left:0;right:0;width:100%;height:2px;background-color:#f0f2f3}.pdk-self-service-panel__progress-fill{width:var(--progress-bar-fill-width, \"0%\");background:#dd0d0b;height:100%;min-width:4px;display:none;transition:width .3s ease-in-out;border-top-right-radius:2px;border-bottom-right-radius:2px}@media (min-width: 768px){.pdk-self-service-panel__progress-fill{min-width:8px;border-top-right-radius:4px;border-bottom-right-radius:4px}}.pdk-self-service-panel__progress-fill-completed{border-top-right-radius:0;border-bottom-right-radius:0;width:100%}.pdk-self-service-panel__footer{border-top:1px solid #e1e5e8;background-color:#f9f9f9;display:flex;flex-direction:column;gap:var(--card-gap-y);padding:var(--card-gap-y) var(--card-spacing-x) var(--card-gap-y) var(--card-spacing-x)}.pdk-self-service-panel__actions{top:0;height:48px;width:auto;display:flex;align-items:center;flex-shrink:0;flex-grow:1;position:absolute;color:var(--color-button-background-primary-base)}@media (min-width: 768px){.pdk-self-service-panel__actions{height:72px}}.pdk-self-service-panel__actions>button{border-radius:50%;display:flex;text-align:center;justify-content:center;align-items:center;padding:0;gap:0;flex-shrink:0;height:40px;width:40px;max-height:40px;max-width:40px;min-height:40px;min-width:40px;cursor:pointer;background-color:transparent;border:none}.pdk-self-service-panel__actions>button:active,.pdk-self-service-panel__actions>button.active{transform:scale(.98)}.pdk-self-service-panel__actions>button:hover,.pdk-self-service-panel__actions>button:active,.pdk-self-service-panel__actions>button.active{outline:2px solid transparent;background-color:#fcede8}@media (min-width: 768px){.pdk-self-service-panel__actions>button{height:53px;width:53px;max-height:53px;max-width:53px;min-height:53px;min-width:53px}}.pdk-self-service-panel__actions>button>svg{transform:scale(.75)}@media (min-width: 768px){.pdk-self-service-panel__actions>button>svg{transform:scale(1)}}.pdk-self-service-panel__actions-back{left:4px}@media (min-width: 768px){.pdk-self-service-panel__actions-back{left:8px}}.pdk-self-service-panel__actions-close{right:4px}@media (min-width: 768px){.pdk-self-service-panel__actions-close{right:8px}}`;
var k = Object.defineProperty, w = Object.getOwnPropertyDescriptor, a = (e, s, r, i) => {
  for (var n = i > 1 ? void 0 : i ? w(s, r) : s, p = e.length - 1, d; p >= 0; p--)
    (d = e[p]) && (n = (i ? d(s, r, n) : d(n)) || n);
  return i && n && k(s, r, n), n;
};
let t = class extends v {
  constructor() {
    super(), this.show = !1, this.fullscreen = !1, this.showProgress = !1, this.noAnimation = !1, this.showBackButton = !1, this.progressWidth = 0, this.title = "", this.params = "", this.closed = !0, this.size = "medium";
  }
  back() {
    const e = new CustomEvent("back", { bubbles: !0, composed: !0 });
    this.dispatchEvent(e);
  }
  close() {
    const e = l.getActiveParams(this.params);
    m.removeQueryParams([l.queryParamKey, ...e]);
    const s = new CustomEvent("close", { bubbles: !0, composed: !0 });
    this.dispatchEvent(s);
  }
  get cssClasses() {
    return [
      "pdk-self-service-panel",
      `pdk-self-service-panel--${this.size}`,
      !this.closed && this.show && "pdk-self-service-panel--show",
      this.show && "pdk-self-service-panel--showing",
      this.fullscreen && "pdk-self-service-panel--fullscreen",
      !this.noAnimation && "pdk-self-service-panel--animate"
    ].filter(Boolean).join(" ");
  }
  get backdropCssClasses() {
    return [
      "pdk-self-service-panel__backdrop",
      !this.closed && this.show && "pdk-self-service-panel__backdrop--show",
      this.show && "pdk-self-service-panel__backdrop--showing",
      "pdk-self-service-panel--animate"
    ].filter(Boolean).join(" ");
  }
  get progressStyle() {
    return [
      this.progressWidth > 0 && `--progress-bar-fill-width: ${this.progressWidth}%`
    ].filter(Boolean).join(" ");
  }
  get progressFillCssClasses() {
    return [
      "pdk-self-service-panel__progress-fill",
      this.progressWidth >= 100 && "pdk-self-service-panel__progress-fill-completed"
    ].filter(Boolean).join(" ");
  }
  render() {
    const e = { "pdk-self-service-panel__header-with-progress": this.showProgress };
    return c`
            <div
              class="${this.cssClasses}"
              tabindex="-1"
              aria-labelledby="offcanvasWithBothOptionsLabel">
              <header class="pdk-self-service-panel__header ${g(e)}">
                <div class="pdk-self-service-panel__actions pdk-self-service-panel__actions-back">
                    ${this.showBackButton ? c`<button @click="${this.back}">
                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.25 15.3125L10.25 6.3125C10.625 5.9375 11.3125 5.9375 11.6875 6.3125C12.0625 6.6875 12.0625 7.375 11.6875 7.75L4.375 15H32C32.5 15 33 15.5 33 16C33 16.5625 32.5 17 32 17H4.375L11.6875 24.3125C12.0625 24.6875 12.0625 25.375 11.6875 25.75C11.3125 26.125 10.625 26.125 10.25 25.75L1.25 16.75C0.875 16.375 0.875 15.6875 1.25 15.3125Z" fill="#DD0D0B"/>
                        </svg>
                    </button>` : ""}
                </div>
                <div class="pdk-self-service-panel__header-content pdk-self-service-panel__header-content--title">
                    ${this.title}
                </div>
                <div class="pdk-self-service-panel__actions pdk-self-service-panel__actions-close">
                  <button @click="${this.close}">
                      <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.25 25.75L12 17.4375L3.6875 25.75C3.3125 26.125 2.6875 26.125 2.25 25.75C1.875 25.3125 1.875 24.6875 2.25 24.3125L10.5625 16L2.25 7.75C1.875 7.375 1.875 6.75 2.25 6.3125C2.6875 5.9375 3.3125 5.9375 3.6875 6.3125L12 14.625L20.25 6.3125C20.625 5.9375 21.25 5.9375 21.6875 6.3125C22.0625 6.75 22.0625 7.375 21.6875 7.75L13.375 16L21.6875 24.3125C22.0625 24.6875 22.0625 25.3125 21.6875 25.75C21.25 26.125 20.625 26.125 20.25 25.75Z" fill="#DD0D0B"/>
                      </svg>
                  </button>
                </div>
                <div class="pdk-self-service-panel__progress" style="${this.progressStyle}">
                    <div class="${this.progressFillCssClasses}"></div>
                </div>
              </header>
              <div class="pdk-self-service-panel__body">
                  <slot></slot>            
              </div>
            </div>
            <div class="${this.backdropCssClasses}" @click="${this.close}"></div>`;
  }
  async firstUpdated() {
    var r;
    await new Promise((i) => setTimeout(i, 0)), this.setAttribute(l.dataPdkOffCanvas, "");
    const e = (r = this.shadowRoot) == null ? void 0 : r.querySelector(".pdk-offcanvas");
    e && e.addEventListener("animationend", (i) => {
      i.animationName === "fadeOut" && (this.closed = !0, this.dispatchEvent(new CustomEvent("on-closed", {
        detail: { id: this.id },
        bubbles: !0,
        composed: !0
      }))), i.animationName === "fadeIn" && (this.closed = !1);
    });
    const s = new URL(document.URL);
    if (s.searchParams.has(l.queryParamKey)) {
      const i = s.searchParams.get(l.queryParamKey);
      this.id === i && (this.show = !0);
    }
  }
  updated(e) {
    super.updated(e);
    const s = () => window.innerWidth - document.documentElement.clientWidth;
    if (e.has("show")) {
      this.show ? (document.body.style.overscrollBehavior = "none", document.body.style.marginRight = `${s()}px`, document.body.style.overflow = "hidden", this.closed = !1) : (document.body.style.overscrollBehavior = "", document.body.style.marginRight = "", document.body.style.overflow = "");
      const r = new CustomEvent("visibilityChanged", { bubbles: !0, composed: !0, detail: this.show });
      this.dispatchEvent(r);
    }
  }
  // willUpdate(changedProperties: PropertyValues<this>) {
  //     if (changedProperties.has('show')) {
  //         this.closed = false;
  //     }
  // }
};
t.styles = h`${f(b)}`;
a([
  o({ type: Boolean })
], t.prototype, "show", 2);
a([
  o({ type: Boolean, attribute: "fullscreen" })
], t.prototype, "fullscreen", 2);
a([
  o({ type: Boolean, attribute: "show-progress" })
], t.prototype, "showProgress", 2);
a([
  o({ type: Boolean, attribute: "no-animation" })
], t.prototype, "noAnimation", 2);
a([
  o({ type: Boolean, attribute: "show-back-button" })
], t.prototype, "showBackButton", 2);
a([
  o({ type: Number, attribute: "progress-width" })
], t.prototype, "progressWidth", 2);
a([
  o({ type: String })
], t.prototype, "title", 2);
a([
  o({ type: String })
], t.prototype, "params", 2);
a([
  o({ type: Boolean, attribute: !1 })
], t.prototype, "closed", 2);
a([
  o({ type: String, attribute: !1 })
], t.prototype, "size", 2);
t = a([
  u("pdk-self-service-panel")
], t);
export {
  t as PdkSelfServicePanel
};
//# sourceMappingURL=PdkSelfServicePanel.js.map
